import React from 'react';
import { Modal } from 'react-bootstrap'
import UsuariosComercios from './UsuariosComercios'

class UsuariosComerciosModal extends React.Component {
    render() {
        return (
            <Modal
                {...this.props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Vendedores del comercio
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <UsuariosComercios newuser={ () => this.props.newuser() } userToken={this.props.userToken} id={this.props.id} />
                </Modal.Body>
            </Modal>
        );
    }
}

export default UsuariosComerciosModal;